<template>
  <SysDialog
    v-model="dialog"
    :largura="400"
    titulo="Novo Email"
    txt-botao="Salvar"
    @click:primary="salvar()"
    @click:hidden-dialog="fecharDialog()"
  >
    <template #ativador>
      <SysBtn :size="1" class="float-right ml-2" @click="dialog = true">
        <v-icon color="#777777" size="20">mdi-plus</v-icon>
        <span class="ml-1">Novo</span>
      </SysBtn>
    </template>

    <v-text-field
      v-model="email"
      :error-messages="emailErrors"
      outlined
      label="Digite Email"
      @input="$v.email.$touch()"
      @blur="$v.email.$touch()"
      @keyup.enter="salvar()"
    ></v-text-field>
  </SysDialog>
</template>

<script>
import Api from "@/api/api";
import SysDialog from "@/components/padraoDeLayout/SysDialog";
import { required, email } from "vuelidate/lib/validators";

export default {
  components: { SysDialog },
  data: () => ({
    dialog: false,
    email: ''
  }),
  validations: {
    email: { required, email }
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push("Campo Obrigatório.");
      !this.$v.email.email && errors.push("Email Inválido.");
      return errors;
    }
  },
  methods: {
    fecharDialog() {
      this.dialog = false;
      this.email = '';
      this.$v.$reset();
    },
    salvar() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      Api.post('diagnostico/clientes/inatividade-vendas/configuracao-email/salvar-email', { email: this.email })
        .then(() => {
          this.fecharDialog();
          this.$emit('atualizar-virtual-scroll');
      	});
    }    
  },
}

</script>